export default __webpack_public_path__ + "static/media/mp-picpay.e61d6003.svg";